const root = document.getElementById('root')!;

// Dev only: ?locale=nl-BE overrides the locale.
const devLocale = import.meta.env.DEV ? new URLSearchParams(window.location.search).get('locale') : null;

const locale = devLocale || root.dataset.locale;
const localeFallback = 'en';

const drupalParams = {
  locale: locale ?? localeFallback,
};

export default drupalParams;
